import React from "react";
import { FaChevronRight } from "react-icons/fa";

interface ButtonProps {
  onClick?: () => void;
  children: React.ReactNode;
  variant?: "primary" | "secondary" | "outline";
  className?: string;
  disabled?: boolean;
  type?: "button" | "submit" | "reset";
  withCaret?: boolean;
}

const Button: React.FC<ButtonProps> = ({
  onClick,
  children,
  variant = "primary",
  className = "",
  disabled = false,
  type = "button",
  withCaret = false,
}) => {
  const baseStyles = "px-4 py-2 rounded focus:outline-none transition";

  const variantStyles = {
    primary: disabled
      ? "bg-green-500 text-white border opacity-50 cursor-not-allowed"
      : "bg-green-500 text-white border hover:bg-green-600",
    secondary: disabled
      ? "border-solid bg-white border border-green-500 rounded-md text-gray-600 border opacity-50 cursor-not-allowed"
      : "border-solid bg-white border border-green-500 rounded-md text-gray-600 border hover:bg-gray-50",
    outline: disabled
      ? "bg-white text-gray-800 border border-gray-300 opacity-50 cursor-not-allowed"
      : "bg-white text-gray-800 border border-gray-300 hover:bg-gray-100",
  };

  const caretStyles = withCaret ? "caret" : "";

  return (
    <button
      onClick={onClick}
      className={`${baseStyles} ${variantStyles[variant]} ${caretStyles} ${className}`}
      disabled={disabled}
      type={type}
    >
      {children}
      {withCaret && <FaChevronRight className="caret-icon" size={14} />}
    </button>
  );
};

export default Button;
